export const AppContainerId = 'veilederBetalingskalkulator';